const elements = document.querySelectorAll('.js-banner-image');

function update(img) {
  const image = img;
  const newSrc =
    typeof image.currentSrc === 'undefined' ? image.src : image.currentSrc;

  if (image.currentImageSource !== newSrc) {
    image.currentImageSource = newSrc;
    image.element.style.backgroundImage = `url("${image.currentImageSource}")`;
  }
}

function responsiveBackgroundImage(img) {
  img.addEventListener('load', () => {
    update(img);
  });

  if (img.complete) {
    update(img);
  }
}

const bannerImage = function() {
  if (elements === null) {
    return;
  }

  for (let i = elements.length - 1; i >= 0; i -= 1) {
    const element = elements[i];
    const img = element.querySelector('img');
    img.currentImageSource = '';
    img.element = element;
    responsiveBackgroundImage(img);
  }
};

export default bannerImage;



// WEBPACK FOOTER //
// ./src/scripts/modules/banner-image.js